/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_ForgejoInputs */



/**
* | output |
* | --- |
* | "Repositories from your self-hosted Forgejo." |
*
* @param {Spaces_Gallery_Desc_ForgejoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_forgejo = /** @type {((inputs?: Spaces_Gallery_Desc_ForgejoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_ForgejoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Repositories aus deinem selbst gehosteten Forgejo.")
	return /** @type {LocalizedString} */ ("Repositories from your self-hosted Forgejo.")
});